import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { vehicleRegistrationAPI } from '../services/api';
import DataEntryForm from './DataEntryForm';
import SpreadsheetReport from './SpreadsheetReport';
import VehicleStatisticManagement from './VehicleStatisticManagement';
import UserManagement from './UserManagement';
import DocumentManagement from './DocumentManagement';
import DocumentList from './DocumentList';
import UserProfile from './UserProfile';
import LicensePlateManagement from './LicensePlateManagement';
import SpecialMotoManagement from './SpecialMotoManagement';
import VehicleRegistrationReportManagement from './VehicleRegistrationReportManagement';
import VehicleDetailManagement from './VehicleDetailManagement';
import ReportReviewManagement from './ReportReviewManagement';
import './VehicleRegistrationDashboard.css';

// SVG Icons
const Icons = {
  Edit: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  Report: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Chart: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
      <line x1="2" y1="20" x2="22" y2="20" />
    </svg>
  ),
  SearchCheck: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
      <path d="m9 11 2 2 4-4" />
    </svg>
  ),
  Review: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  ),
  Car: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13" />
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
  ),
  Plate: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <line x1="6" y1="12" x2="18" y2="12" />
      <circle cx="4.5" cy="8.5" r="0.8" fill="currentColor" />
      <circle cx="19.5" cy="8.5" r="0.8" fill="currentColor" />
    </svg>
  ),
  Moto: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="5" cy="16" r="3" />
      <circle cx="19" cy="16" r="3" />
      <path d="M12 17h4l3-7h-4.5L12 13l-3-3H4" />
      <polyline points="15 6 13 10 9 10" />
    </svg>
  ),
  Users: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Folder: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  ),
  User: () => (
    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Shield: () => (
    <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '20px', height: '20px' }}>
      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
    </svg>
  ),
  Menu: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '20px', height: '20px' }}>
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  ),
  ChevronDown: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '12px', height: '12px' }}>
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  Video: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '15px', height: '15px' }}>
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </svg>
  ),
  Logout: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: '15px', height: '15px' }}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  )
};

const VehicleRegistrationDashboard = () => {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState(
    user.role === 'admin' ? 'spreadsheet' :
      user.role === 'document' ? 'documents' :
        'entry'
  );

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navRef = useRef(null);

  const [businessTypes, setBusinessTypes] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [entryWarning, setEntryWarning] = useState('');
  const [showVideoModal, setShowVideoModal] = useState(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const checkMissingData = async () => {
    if (!user || (user.role !== 'unit' && user.role !== 'supervisor') || !user.unit?.id) return;
    try {
      const params = {
        page: 1,
        limit: 1,
        unitId: user.unit.id,
        sortBy: 'recordDate',
        sortOrder: 'DESC'
      };
      const response = await vehicleRegistrationAPI.getRegistrations(params);
      const lastEntry = response.data.records[0];

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      if (!lastEntry) {
        setEntryWarning('Bạn chưa nhập dữ liệu cho ngày hôm qua và hôm nay.');
        return;
      }

      const lastEntryDate = new Date(lastEntry.recordDate);
      lastEntryDate.setHours(0, 0, 0, 0);

      if (lastEntryDate.getTime() < yesterday.getTime()) {
        setEntryWarning('Cảnh báo: Bạn chưa nhập dữ liệu cho ngày hôm qua.');
      } else if (lastEntryDate.getTime() < today.getTime()) {
        setEntryWarning('Lưu ý: Bạn chưa nhập dữ liệu cho ngày hôm nay.');
      } else {
        setEntryWarning('');
      }

    } catch (error) {
      console.error('Lỗi khi kiểm tra dữ liệu nhập cuối cùng:', error);
    }
  };

  const fetchInitialData = async () => {
    try {
      setLoading(true);
      if (user.role === 'document') {
        setLoading(false);
        return;
      }

      const businessTypesResponse = await vehicleRegistrationAPI.getBusinessTypesWithVehicles();
      setBusinessTypes(businessTypesResponse.data.businessTypes);

      const vehicleTypesResponse = await vehicleRegistrationAPI.getVehicleTypes();
      setVehicleTypes(vehicleTypesResponse.data.vehicleTypes);

      if (user.role === 'admin' || user.role === 'supervisor') {
        const unitsResponse = await vehicleRegistrationAPI.getUnits();
        setUnits(unitsResponse.data.units);
      }
    } catch (error) {
      console.error('Error fetching initial data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInitialData();
    checkMissingData();
  }, [user.role]);

  // Define structured menu categories
  const getMenuCategories = () => {
    if (user.role === 'document') {
      return [
        {
          id: 'doc-group',
          title: 'Tài liệu & Hồ sơ',
          icon: Icons.Folder,
          items: [
            { id: 'documents', label: 'Quản lý tài liệu', icon: Icons.Folder },
            { id: 'profile', label: 'Hồ sơ người dùng', icon: Icons.User }
          ]
        }
      ];
    }

    const categories = [];

    // Nhóm 1: Nghiệp vụ
    const mainOps = [
      { id: 'entry', label: 'Nhập liệu', icon: Icons.Edit },
      { id: 'spreadsheet', label: user.role === 'admin' ? 'Báo cáo tổng hợp' : 'Báo cáo', icon: Icons.Report },
      { id: 'vehicle-details', label: 'Chi tiết phương tiện', icon: Icons.Car },
      { id: 'license-plates', label: 'Đề nghị biển số xe', icon: Icons.Plate },
      { id: 'special-moto', label: 'Xe Máy CĐ', icon: Icons.Moto }
    ];
    categories.push({
      id: 'ops',
      title: 'Nghiệp vụ đăng ký',
      icon: Icons.Edit,
      items: mainOps
    });

    // Nhóm 2: Thống kê & Rà soát
    const statsReviews = [
      { id: 'vehicle-statistics', label: 'Thống kê xe', icon: Icons.Chart },
      { id: 'registration-reports', label: 'Rà soát sở hữu xe', icon: Icons.SearchCheck },
      { id: 'report-reviews', label: 'Rà soát phản ánh', icon: Icons.Review }
    ];
    categories.push({
      id: 'stats',
      title: 'Thống kê & Rà soát',
      icon: Icons.Chart,
      items: statsReviews
    });

    // Nhóm 3: Hệ thống & Tài liệu
    const sysItems = [];
    if (user.role === 'admin') {
      sysItems.push({ id: 'users', label: 'Quản lý người dùng', icon: Icons.Users });
    }
    sysItems.push({
      id: 'documents',
      label: user.role === 'admin' || user.role === 'document' ? 'Quản lý tài liệu' : 'Tài liệu',
      icon: Icons.Folder
    });
    sysItems.push({ id: 'profile', label: 'Hồ sơ cá nhân', icon: Icons.User });

    categories.push({
      id: 'sys',
      title: 'Hệ thống & Tài liệu',
      icon: Icons.Folder,
      items: sysItems
    });

    return categories;
  };

  const menuCategories = getMenuCategories();

  // Find active tab info for title display
  let activeTabLabel = 'Trang chủ';
  let activeCategoryTitle = '';
  for (const cat of menuCategories) {
    const item = cat.items.find(i => i.id === activeTab);
    if (item) {
      activeTabLabel = item.label;
      activeCategoryTitle = cat.title;
      break;
    }
  }

  const handleSelectTab = (tabId) => {
    setActiveTab(tabId);
    setActiveDropdown(null);
    setMobileMenuOpen(false);
  };

  const toggleDropdown = (catId) => {
    setActiveDropdown(activeDropdown === catId ? null : catId);
  };

  if (loading) {
    return (
      <div className="dashboard-loading-container">
        <div className="dashboard-spinner"></div>
        <div className="dashboard-loading-text">Đang tải hệ thống quản lý đăng ký xe...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-layout topnav-mode">
      {/* Top Navigation Bar - Full Width, Clean & Flat */}
      <header className="topnav-header" ref={navRef}>
        <div className="topnav-container">
          {/* Left: Brand Logo */}
          <div className="topnav-brand">
            <div className="brand-icon-wrap">
              <Icons.Shield />
            </div>
            <div className="brand-text">
              <span className="brand-title">QL ĐĂNG KÝ XE</span>
            </div>
          </div>

          {/* Center: Grouped Menu Items with Dropdowns */}
          <nav className="topnav-menu">
            {menuCategories.map((category) => {
              const isCatActive = category.items.some(item => item.id === activeTab);
              const isOpen = activeDropdown === category.id;
              const CatIcon = category.icon;

              return (
                <div key={category.id} className="topnav-dropdown-wrap">
                  <button
                    className={`topnav-dropdown-trigger ${isCatActive ? 'active' : ''} ${isOpen ? 'open' : ''}`}
                    onClick={() => toggleDropdown(category.id)}
                    title={category.title}
                  >
                    <span className="cat-trigger-icon">
                      <CatIcon />
                    </span>
                    <span className="cat-trigger-label">{category.title}</span>
                    <span className={`cat-trigger-chevron ${isOpen ? 'rotate' : ''}`}>
                      <Icons.ChevronDown />
                    </span>
                  </button>

                  {/* Dropdown Menu Popup */}
                  {isOpen && (
                    <div className="topnav-dropdown-menu">
                      <div className="dropdown-menu-header">{category.title}</div>
                      {category.items.map((item) => {
                        const ItemIcon = item.icon;
                        const isItemActive = activeTab === item.id;
                        return (
                          <button
                            key={item.id}
                            className={`dropdown-menu-item ${isItemActive ? 'active' : ''}`}
                            onClick={() => handleSelectTab(item.id)}
                          >
                            <span className="dropdown-item-icon">
                              <ItemIcon />
                            </span>
                            <span className="dropdown-item-label">{item.label}</span>
                            {isItemActive && <span className="dropdown-active-dot" />}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </nav>

          {/* Right: Actions & User Role */}
          <div className="topnav-actions">
            <span className="user-role-badge">
              {user.role === 'admin' ? 'Quản trị viên' :
                user.role === 'document' ? 'QL Tài liệu' :
                  user.unit?.name || 'Cán bộ đơn vị'}
            </span>

            <button onClick={() => setShowVideoModal(true)} className="topbar-btn help-btn" title="Xem video hướng dẫn">
              <Icons.Video />
              <span>Hướng dẫn</span>
            </button>

            <button onClick={logout} className="topbar-btn logout-btn" title="Đăng xuất">
              <Icons.Logout />
              <span>Đăng xuất</span>
            </button>

            {/* Mobile Hamburger Button */}
            <button
              className="mobile-hamburger-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              title="Menu di động"
            >
              <Icons.Menu />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Drawer */}
      {mobileMenuOpen && (
        <div className="mobile-drawer-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-drawer-content" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-drawer-header">
              <span className="mobile-drawer-title">Danh mục chức năng</span>
              <button className="mobile-drawer-close" onClick={() => setMobileMenuOpen(false)}>✕</button>
            </div>
            <div className="mobile-drawer-body">
              {menuCategories.map((category) => (
                <div key={category.id} className="mobile-menu-group">
                  <div className="mobile-group-title">{category.title}</div>
                  <div className="mobile-group-items">
                    {category.items.map((item) => {
                      const ItemIcon = item.icon;
                      const isItemActive = activeTab === item.id;
                      return (
                        <button
                          key={item.id}
                          className={`mobile-nav-item ${isItemActive ? 'active' : ''}`}
                          onClick={() => handleSelectTab(item.id)}
                        >
                          <span className="mobile-item-icon"><ItemIcon /></span>
                          <span className="mobile-item-label">{item.label}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Subbar: Active Breadcrumb Bar */}
      <div className="topnav-subbar">
        <div className="subbar-content">
          <div className="subbar-breadcrumb">
            <span className="breadcrumb-group">{activeCategoryTitle}</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">{activeTabLabel}</span>
          </div>
        </div>
      </div>

      {/* Missing Data Warning Banner */}
      {entryWarning && (
        <div className="entry-warning-banner">
          <span className="warning-icon">⚠️</span>
          <p>{entryWarning}</p>
        </div>
      )}

      {/* Main Full-Width Content Container */}
      <main className="dashboard-content-full">
        <div className="tab-card-wrapper">
          {activeTab === 'entry' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <DataEntryForm
              businessTypes={businessTypes}
              vehicleTypes={vehicleTypes}
              units={units}
              user={user}
              onDataSaved={() => {
                fetchInitialData();
                checkMissingData();
              }}
            />
          )}

          {activeTab === 'spreadsheet' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <SpreadsheetReport user={user} />
          )}

          {activeTab === 'vehicle-statistics' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <VehicleStatisticManagement user={user} />
          )}

          {activeTab === 'registration-reports' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <VehicleRegistrationReportManagement user={user} />
          )}

          {activeTab === 'report-reviews' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <ReportReviewManagement user={user} />
          )}

          {activeTab === 'vehicle-details' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <VehicleDetailManagement user={user} />
          )}

          {activeTab === 'license-plates' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <LicensePlateManagement />
          )}

          {activeTab === 'special-moto' && (user.role === 'admin' || user.role === 'unit' || user.role === 'supervisor') && (
            <SpecialMotoManagement user={user} />
          )}

          {activeTab === 'users' && user.role === 'admin' && (
            <UserManagement user={user} />
          )}

          {activeTab === 'documents' && (
            user.role === 'admin' || user.role === 'document' ?
              <DocumentManagement /> :
              <DocumentList />
          )}

          {activeTab === 'profile' && (
            <UserProfile />
          )}
        </div>
      </main>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="video-modal-overlay" onClick={() => setShowVideoModal(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-close-btn" onClick={() => setShowVideoModal(false)}>✕</button>
            <div className="video-modal-header">
              <span className="video-modal-icon">🎥</span>
              <h3>Hướng dẫn sử dụng hệ thống Quản lý Đăng ký xe</h3>
            </div>
            <div className="video-wrapper">
              <video controls autoPlay style={{ width: '100%', maxHeight: '70vh', borderRadius: '10px' }}>
                <source src="/huongdan.mp4" type="video/mp4" />
                Trình duyệt của bạn không hỗ trợ phát video.
              </video>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleRegistrationDashboard;


